<script setup>
defineProps({
    label: {
        type: String,
        default: '',
    },
});
</script>

<template>
    <div :class="[label ? 'px-1 pb-1 pt-5' : 'p-1']">
        <div
            v-if="label"
            class="mb-1.5 px-2 text-xs font-bold uppercase tracking-tight"
        >
            {{ label }}
        </div>

        <slot />
    </div>
</template>
